<template>
  <div
    :class="[
      'preloader',
      title ? 'with-title' : '',
      inline ? 'inline' : '',
      color
    ]"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="22.22222222222222 22.22222222222222 44.44444444444444 44.44444444444444"
      style="transform: rotate(0deg);"
    >
      <circle
        fill="transparent"
        cx="44.44444444444444"
        cy="44.44444444444444"
        r="20"
        stroke-width="4.444444444444445"
        stroke-dasharray="125.664"
        stroke-dashoffset="125.66370614359172px"
        class="v-progress-circular__overlay"
      ></circle>
    </svg>
    <h5 v-if="title" v-text="title"></h5>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    }
  }
};
</script>
<style lang="stylus">
.preloader
  color blue_brand
  width 10vmin
  height 10vmin
  opacity 0.4
  &:not(.inline)
    center()
  &.inline
    display inline-block
    width 30px
    height 30px
    position relative
    text-align left
    marg('m', right)
  svg
      animation progress-circular-rotate 1.4s linear infinite
      width 100%
      height 100%
      margin auto
      position absolute
      top 0
      bottom 0
      left 0
      right 0
      z-index 0
  circle
    animation: progress-circular-dash 1.4s ease-in-out infinite;
    stroke-linecap round
    stroke-dasharray 80, 200
    stroke-dashoffset 0px
    stroke currentColor
    z-index 2
    transition all 0.6s ease-in-out

.preloader
  &.inline
    width 20px
    height @width
  &.inline-mid
    width 40px
    height @width
    color gray_5
  &.with-title
    color blue_brand
    height auto
    width auto
    display flex
    flex-direction column
    align-items center
    justify-content flex-start
    opacity 0.6
    h5
      font-size 16px
      color blue_brand
      margin 10px 0 0 0
      width 100%
      white-space nowrap
    svg
      right initial
      position relative
      margin 0
      max-width 90px
  &.white
    color gray_0
    opacity 0.6
@keyframes progress-circular-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0px;
  }
  50% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -125px;
  }
}

@keyframes progress-circular-rotate {
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
</style>
